module.exports = __webpack_public_path__ + "media/markers/marker-teal-c824fc54.svg";